import Endpoints from '../config/endpoint';
import { ApiMethodType } from '../enums/api-constants';
import { performRequest } from '../network';
import { TenantRegionalSettings } from '../singleton/tenant-settings-manager';

const unwrapSettings = (data: unknown): TenantRegionalSettings => {
  const response = data as
    | TenantRegionalSettings
    | { data?: TenantRegionalSettings };
  return (
    'data' in response && response.data ? response.data : response
  ) as TenantRegionalSettings;
};

/**
 * Write-only. Regional settings are READ off `GET /config` (public, fetched
 * pre-login at boot — see `TenantConfigManager`), not from this endpoint;
 * the backend no longer exposes a `GET /tenant-settings`.
 */
export const updateTenantRegionalSettings = async (
  settings: TenantRegionalSettings
): Promise<TenantRegionalSettings> => {
  const { modifiedAtUtc, ...regionalSettings } = settings;
  const response = await performRequest<TenantRegionalSettings>(
    Endpoints.TENANT_SETTINGS,
    ApiMethodType.PATCH,
    {
      ...regionalSettings,
      ...(modifiedAtUtc ? { expectedModifiedAtUtc: modifiedAtUtc } : {}),
    }
  );
  return unwrapSettings(response.data);
};
